const VariaveisEstilo = (config) => {
    if (config == null) {
        return
    }

    document.documentElement.style.setProperty('--primaria', config.corDominante)
}

export default VariaveisEstilo